module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av196-719101d711043711f67ac597af49d265.jpg";